import type { RouteRecordRaw } from 'vue-router';
import { defineComponent } from 'vue';
import { FeatureFlags } from '@/plugins/launchDarkly/featureFlags';

// Placeholder component for routes without views
const PlaceholderComponent = defineComponent({
  template: `
    <div class="q-pa-md">
      <h4>Page Under Development</h4>
      <p>This page is currently under development.</p>
    </div>
  `
});

export const paymentsRoutes: RouteRecordRaw[] = [
  {
    path: '/payments',
    name: 'Payments',
    component: PlaceholderComponent,
    redirect: { name: 'PaymentsOverview' },
    meta: {
      requiresAuth: true,
      navigation: {
        label: 'Payments',
        icon: 'payments-icon.svg',
        order: 5,
        showInMenu: true,
        featureFlag: FeatureFlags.PAYMENTS_INTEGRATION,
        permissions: {
          rbacRoles: ['dashboardnav-read']
        }
      }
    },
    children: [
      {
        path: 'overview/',
        name: 'PaymentsOverview',
        component: PlaceholderComponent,
        meta: {
          title: "Payments - Overview",
          requiresAuth: true,
          navigation: {
            parent: 'Payments',
            parentIcon: 'payments-icon.svg',
            label: 'Overview',
            order: 1,
            showInMenu: true,
            featureFlag: FeatureFlags.PAYMENTS_INTEGRATION,
            permissions: {
              ownerRoles: ['Publisher', 'Retailer']
            }
          }
        }
      },
      {
        path: 'wallets/',
        name: 'PaymentsWallets',
        component: PlaceholderComponent,
        meta: {
          title: "Payments - Wallets",
          requiresAuth: true,
          navigation: {
            parent: 'Payments',
            parentIcon: 'payments-icon.svg',
            label: 'Wallets',
            order: 2,
            showInMenu: true,
            featureFlag: FeatureFlags.PAYMENTS_INTEGRATION,
            permissions: {
              ownerRoles: ['Publisher', 'Retailer']
            }
          }
        }
      },
      {
        path: 'settings/',
        name: 'PaymentsSettings',
        component: PlaceholderComponent,
        meta: {
          title: "Payments - Settings",
          requiresAuth: true,
          navigation: {
            parent: 'Payments',
            parentIcon: 'payments-icon.svg',
            label: 'Settings',
            order: 3,
            showInMenu: true,
            featureFlag: FeatureFlags.PAYMENTS_INTEGRATION,
            permissions: {
              ownerRoles: ['Publisher', 'Retailer']
            }
          }
        }
      }
    ]
  }
];